import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss'],
    standalone: false
})
export class FaqsComponent implements OnInit {
  toggleClass: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
